<template>
    <fieldset>
        <legend>
            <label>
                <input type="radio" name="shippingSource" @change="sourceChanged">
                Search in all available addresses <span>({{searchResults.length}}/{{count}})</span>
            </label>
        </legend>
        <div v-if="enabled">
            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Search for ZIP-Code..." v-model="query" @keyup.stop.prevent="search">
                    <div class="input-group-addon" @click="search">
                        <i v-if="searching" class="fa fa-fw fa-spin fa-spinner"></i>
                        <i v-else class="fa fa-fw fa-search"></i>
                    </div>
                    <div v-if="false" class="input-group-addon">
                        <i class="fa fa-share"></i>
                    </div>
                </div>
            </div>
            <div :class="resultGroupClass">
                <select class="form-control" @change="selectResult">
                    <template v-if="searchResults.length">
                        <option v-for="(address, index) in searchResults" :key="address.id" :value="index" :selected="index == 0">
                            {{index + 1}}. {{address.company}}, {{address.street}}, {{address.zip}} {{address.city}}, {{address.countryName}}
                        </option>
                    </template>
                    <template v-else>
                        <option disabled selected>[ No list items available ]</option>
                    </template>
                </select>
            </div>
        </div>
    </fieldset>
</template>
<script>

import {clone} from "lodash";

export default {

    data() {
        return {
            count: 0,
            query: '',
            searchResults: [],
            enabled: false,
            searching: false,
            address: {
                company: '',
                street: '',
                city: '',
                zip: '',
                country: '',
                countryName: '',                
            },
            resultGroupClass: {
                "form-group": true,
                "has-error": false
            }
        }
    },

    computed: {

    },

    created() {
        new Form().get('/api/addressbook/count').then(({count}) => this.count = count);
        App.event.listen('shipping.source.changed', ({who}) => {
            this.enabled = who == 'search';
            this.emitChange();
        });
    },

    methods: {

        selectResult({target}) {
            let index = target.value;
            this.address = this.searchResults[index];
            this.emitChange();
        },

        sourceChanged() {
            App.event.fire('shipping.source.changed', { who: 'search' });
        },

        search() {
            if (this.query.length) {
                this.searching = true;
                new Form({query: this.query}).post('/api/addressbook')
                    .then((results) => {
                        this.searching = false;
                        this.searchResults = results;

                        if (results.length) {
                            this.selectResult({target: {value: 0}});
                        }
                    });
            } else {
                this.searchResults = [];
                this.address = {
                    company: '',
                    street: '',
                    city: '',
                    zip: '',
                    country: '',
                    countryName: '',                
                }
                this.emitChange();
            }
            
        },

        validate() {
            this.resultGroupClass['has-error'] = this.searchResults.length == 0;
            return this.enabled ? (this.searchResults.length != 0) : true;
        },

        emitChange() {
            if (this.enabled) {
                this.$emit('change', {
                    address: clone(this.address),
                    isNew: false
                });
            }
        }

    }
}
</script>
